var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-panel"},[_c('h1',{staticClass:"card-title"},[_vm._v("Sign in")]),_c('p',{staticClass:"card-hint"},[_vm._v("Watch every vessel's position, fuel and performance as it happens.")]),_c('LoginForm',{on:{"onSuccess":_vm.onSuccess,"onFailure":_vm.onFailure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }